<template>
  <div class="situation-container">
    <el-form size="small" inline class="situation-head">
      <el-form-item>
        <!-- <el-date-picker v-model="searchTime" type="datetimerange" range-separator="至"
          :start-placeholder="nowData" :end-placeholder="nowData" format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker> -->
        <el-date-picker v-model="searchTime" type="date" format="yyyy-MM-dd" align="right"
          :clearable="false" :picker-options="pickerOptions" placeholder="今天">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input size="small" placeholder="请输入接口地址" v-model="input" class="search-left_input">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search()">查询</el-button>
      </el-form-item>

    </el-form>
    <!-- 接口数据分析 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <b class="font-size-18">流量数据</b>
          </div>
          <AnalyzeData :analyzeData="analyzeData" v-loading="apiDataLoading"/>
          <!-- <AnalyzeData :analyzeData="analyzeData" :analyzeTime="analyzeTime" /> -->
        </el-card>
      </el-col>
    </el-row>
    <!-- 近30天接口请求趋势 -->
    <AnalyzeTendency
    :xBarArray="xBarArray"
    :yBarArray="yBarArray"
    :analyzeTime="analyzeTime"
    isMountedRender
    :recentTdendencyLoading="recentTdendencyLoading"
      :url="url" />

    <el-row type="flex" :gutter="20">
      <el-col :span="12" class="margin-top-20">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <!-- <i class="el-icon-s-data"></i> -->
            <b class="font-size-18">接口请求耗时分布</b>
          </div>
          <div style="height:300px"  v-loading="apiCostLoading">
            <!-- 接口请求耗时分布柱状图 -->
            <InterfaceTime v-if="isShowBar" isMountedRender :xDataArray="xDataArray"
              :yDataArray="yDataArray" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" class="margin-top-20">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <!-- <i class="el-icon-s-data"></i> -->
            <b class="font-size-18">接口请求来源分布</b>
          </div>
          <div style="height:300px">
            <!-- source饼图分布 -->
            <SourcePie isMountedRender :pieDataArray="pieDataArray" v-loading="sourcePieLoading"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- source-n的饼图展示 -->
    <div :v-if="isShowSourcePieDataN">
      <el-row :gutter="20">
        <el-col v-for="(item,index) in sourcePieDataN" :key="index" :span="12"
          class="margin-top-20">
          <el-card shadow="never">
            <div slot="header" class="clearfix">
              <!-- <i class="el-icon-s-data"></i> -->
              <b class="font-size-18">{{item.name}}版本请求分布</b>
            </div>
            <div style="height:300px">
              <!-- source饼图分布{{item}} -->
              <SourcePie isMountedRender :pieDataArray="item.appVersions" />
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- das你好 -->
  </div>
</template>

<script>
import Moment from 'moment';
import { parseTime, getMiddleData } from '@/utils';
import { mapGetters } from 'vuex';
import {
  queryApiStat,
  queryApiCost,
  queryApiCount,
  queryApiSource,
} from '@/api/tracking';
import AnalyzeData from '../api-analysis/components/data.vue';
import AnalyzeTendency from '../api-analysis/components/tendency-chart.vue';
import InterfaceTime from './components/interface-time.vue';
import SourcePie from './components/source-pie.vue';

export default {
  name: 'SituationInterface',
  components: {
    AnalyzeData,
    AnalyzeTendency,
    InterfaceTime,
    SourcePie,
  },
  data() {
    return {
      input: '',
      url: '',
      searchTime: '',
      xDataArray: [], // 延时柱形图
      yDataArray: [],
      xBarArray: [], // 30天柱形图
      yBarArray: [],
      analyzeTime: '', // 接口请求趋势
      pieDataArray: [{ name: '暂无数据', value: 0 }],
      nowData: '',
      recentTdendencyLoading: false,
      sourcePieLoading: false,
      apiCostLoading: false,
      apiDataLoading: false,
      isShowBar: false,
      isShowPie: false,
      isShowTendency: false,
      // isShowTendForge: true,
      analyzeData: [
        {
          title: '当前服务名',
          data: '全部',
          tip: '当前服务名',
        },
        {
          title: '接口请求数',
          data: 0,
          key: 'apiRequest',
          tip: '发起请求总数量',
        },
        {
          key: 'apiError',
          title: '接口错误数',
          data: 0,
          tip: '发起请求失败总数量',
        },
        {
          key: 'apiErrorScale',
          title: '接口异常率',
          data: 0,
          tip: '（接口错误数 / 接口请求数） * 100%',
        },
        {
          key: 'costAvg',
          title: '平均耗时',
          data: 0,
          tip: '从接收请求到完成响应的平均耗时',
        },
      ],
      analyzeTimeFrom: '',
      analyzeTimeTo: '',
      dataAs: {
        // source-n饼图伪数据(开发测试使用)
        apiSources: [
          {
            key: 'one',
            name: 'one',
            currentCount: 28,
            appVersions: [
              {
                key: 'one-one',
                currentCount: 11,
              },
              {
                key: 'one-two',
                currentCount: 11,
              },
              {
                key: 'one-three',
                currentCount: 11,
              },
            ],
          },
          {
            key: 'two',
            name: 'two',
            currentCount: 62,
            appVersions: [
              {
                key: 'two-one',
                currentCount: 22,
              },
              {
                key: 'two-two',
                currentCount: 22,
              },
              {
                key: 'two-three',
                currentCount: 22,
              },
            ],
          },
          {
            key: 'three',
            name: 'three',
            currentCount: 12,
            appVersions: [
              {
                key: 'three-one',
                currentCount: 33,
              },
              {
                key: 'three-two',
                currentCount: 33,
              },
              {
                key: 'three-three',
                currentCount: 33,
              },
            ],
          },
        ],
      },
      isShowSourcePieDataN: false,
      sourcePieDataN: [],
      pickerMinDate: null,
      pickerOptions: {
        // 限制不给选择未来时间
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (date) => {
          const time = date.getTime();
          return time > new Date() * 1;
        },
      },
      startShowThirtyDayData: true,
      startShowBarChartData: true,
    };
  },
  computed: {
    ...mapGetters('app', ['env', 'serverName', 'bizChannel']),
  },
  watch: {
    serverName: {
      handler() {
        this.search();
      },
    },
    env() {
      this.search();
    },
    bizChannel() {
      this.search();
    },
  },
  mounted() {
    this.showList();
    this.getThirtyDayData();
    this.getBarChartData();
  },
  methods: {
    showList() {
      this.searchTime = new Date();
      // this.analyzeTime = new Moment(this.searchTime).format('YYYY-MM-DD');
      // this.nowData = parseTime(nowData).slice(0, 10); // 时间选择器显示当前时间
    },
    search() {
      if (!this.input) {
        this.$message({
          type: 'warning',
          message: '接口地址不能为空',
        });
        return;
      }
      this.isShowBar = false;
      this.isShowPie = false;
      this.isShowTendency = false;
      this.isShowSourcePieDataN = false;
      // console.log('time---', parseTime(this.searchTime).slice(0, 10));
      // 时间格式转换 yyyy-MM-dd HH:mm:ss
      this.analyzeTimeFrom = `${parseTime(this.searchTime).slice(0, 10)} 00:00:00`;
      this.analyzeTimeTo = `${parseTime(this.searchTime).slice(0, 10)} 23:59:59`;
      // console.log('sdd---', this.analyzeTimeFrom, this.analyzeTimeTo);
      const params = {
        uri: this.input,
        analyzeTimeFrom: this.analyzeTimeFrom,
        analyzeTimeTo: this.analyzeTimeTo,
      };
      this.getInterfaceData();
      this.getThirtyDayData();
      this.getBarChartData(params);
      this.getPieChartData(params);
      // this.input = '';
      this.analyzeTimeFrom = '';
      this.analyzeTimeTo = '';
    },
    // 接口请求数据获取
    async getInterfaceData() {
      this.apiDataLoading = true;

      const params = {
        uri: this.input,
        requestTimeFrom: this.analyzeTimeFrom,
        requestTimeTo: this.analyzeTimeTo,
      };
      // console.log('接口请求params', params);
      const { data } = await queryApiStat(params);

      this.apiDataLoading = false;

      // console.log('接口请求data', data);
      this.analyzeData.forEach((item) => {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(item.key)) {
          // eslint-disable-next-line no-param-reassign
          item.data = data[item.key];
          if (item.key === 'apiErrorScale') {
            // eslint-disable-next-line no-param-reassign
            item.data = `${(data[item.key] * 100).toFixed(2)} %`;
          }
        } else if (!item.key) {
          // eslint-disable-next-line no-param-reassign
          item.data = this.serverName ? this.serverName : '全部服务';
        }
      });
    },
    // 近30天的接口数据请求
    async getThirtyDayData() {
      this.recentTdendencyLoading = true;

      this.analyzeTimeFrom = new Moment(this.searchTime)
        .subtract(29, 'days')
        .format('YYYY-MM-DD');
      this.analyzeTimeTo = new Moment(this.searchTime).format('YYYY-MM-DD');

      const middle = getMiddleData(
        'day',
        this.analyzeTimeFrom,
        this.analyzeTimeTo,
        'MM-dd',
      );
      // console.log('middle', middle);
      if (this.startShowThirtyDayData) {
        // console.log('middle', middle);
        this.xBarArray = middle;
        this.yBarArray = [0];
        this.analyzeTime = '';
        this.isShowTendency = true;
        this.startShowThirtyDayData = false;
        this.recentTdendencyLoading = false;

        return;
      }
      this.analyzeTime = new Moment(this.searchTime).format('YYYY-MM-DD');
      this.url = this.input;
      const params = {
        uri: this.input,
        analyzeTimeFrom: this.analyzeTimeFrom,
        analyzeTimeTo: this.analyzeTimeTo,
      };
      // console.log('近30天的接口----params', params, this.analyzeTime);
      const { data } = await queryApiCount(params);
      // console.log('近30天的接口----data', data);

      const yArray = [];
      const xArray = [];
      const yBarArray = [];
      this.analyzeTimeFrom = new Moment(this.searchTime)
        .subtract(29, 'days')
        .format('YYYY-MM-DD');
      this.analyzeTimeTo = new Moment(this.searchTime).format('YYYY-MM-DD');
      // console.log('gagga', this.analyzeTimeFrom, this.analyzeTimeTo);

      data.apiCounts.forEach(({ currentCount, analyzeDate }) => {
        yArray.push(currentCount);
        xArray.push(analyzeDate.slice(-5));
      });
      middle.forEach((item) => {
        const index = xArray.indexOf(item);
        yBarArray.push(index === -1 ? 0 : yArray[index]);
      });
      this.yBarArray = yBarArray;
      this.xBarArray = middle;

      this.recentTdendencyLoading = false;

      this.isShowTendForge = false;
      this.isShowTendency = true;
    },
    // 柱形图接口延时数据获取
    async getBarChartData(params) {
      if (this.startShowBarChartData) {
        this.xDataArray = ['<1秒', '1-5秒', '5-10秒', '10-30秒', '>30秒'];
        this.yDataArray = [0, 0, 0, 0, 0];
        this.isShowBar = true;
        this.startShowBarChartData = false;
        return;
      }
      // this.yDataArray = [
      //   { value: 1, itemStyle: { color: '#3CFC07' } },
      //   { value: 5, itemStyle: { color: '#3CFC07' } },
      //   { value: 12, itemStyle: { color: '#3CFC07' } },
      // ];
      // this.yDataArray = [12, 25, 35, 23, 31];
      // console.log('柱形图接口----params', params);
      this.apiCostLoading = true;

      const { data } = await queryApiCost(params);
      // console.log('柱形图接口----data', data);
      this.apiCostLoading = false;

      const yData = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const pars in data) {
        if (pars) {
          yData.push(data[pars]);
        }
      }
      this.xDataArray = ['<1秒', '1-5秒', '5-10秒', '10-30秒', '>30秒'];
      this.yDataArray = yData;
      this.isShowBar = true;
      // this.yDataArray = yData;
      // console.log(this.yDataArray);
    },
    // 饼图source数据获取
    async getPieChartData(params) {
      this.sourcePieLoading = true;
      // console.log('饼图source--params', params);
      // const pieData = [
      //   { value: 1048, name: '色卡仓小程序' },
      //   { value: 735, name: 'CRM' },
      //   { value: 580, name: 'SRM' },
      //   { value: 200, name: 'BPS/BPS1' },
      // ];
      const { data } = await queryApiSource(params);
      this.sourcePieLoading = false;

      // console.log('饼图source--data', data);
      // console.log('--rr-', this.dataAs); // this.dataAs是则根据接口伪造的测试数据
      // eslint-disable-next-line array-callback-return
      const pieData = []; // 存储source最初始饼图的数据
      const sourceData = []; // 存储source-N个饼图的数据
      data.apiSources.forEach((item) => {
        if (item.appVersions.length > 0) {
          // source-N的数据以数组为单位进去sourceData，就是大的数组里面存入一个个数组
          sourceData.push(
            JSON.parse(
              JSON.stringify({
                name: item.name,
                appVersions: item.appVersions,
                // eslint-disable-next-line comma-dangle
              })
              // eslint-disable-next-line comma-dangle
            )
          );
          // sourceName.push(item.name);
        }
        // eslint-disable-next-line no-param-reassign, no-unused-vars
        item = {
          value: item.currentCount,
          // eslint-disable-next-line no-useless-concat
          name: `${`${item.key}` + '('}${item.currentCount})`,
        };
        pieData.push(item); // 转换并存入source最初始符合饼图的数据
      });
      for (let i = 0; i < sourceData.length; i++) {
        for (let n = 0; n < sourceData[i].appVersions.length; n++) {
          // source-N个饼图的数据信息转换成符合饼图渲染的数据格式
          const sourceNData = {
            value: sourceData[i].appVersions[n].currentCount,
            // eslint-disable-next-line no-useless-concat
            name: `${`${sourceData[i].appVersions[n].key}` + '('}${
              sourceData[i].appVersions[n].currentCount
            })`,
          };
          sourceData[i].appVersions[n] = sourceNData;
          // console.log('uu', sourceData[i][n]);
        }
      }
      // console.log('sourceData', sourceData);
      this.pieDataArray = pieData.length ? pieData : [{ name: '暂无数据', value: 0 }];
      this.sourcePieDataN = sourceData;
      // console.log('sourcePieDataN------', this.sourcePieDataN);
      // console.log('饼图source', pieData, this.sourcePieDataN);
      this.isShowPie = true;
      if (this.sourcePieDataN.length > 0) {
        this.isShowSourcePieDataN = true;
      } else {
        this.isShowSourcePieDataN = false;
      }
    },
  },
};
</script>

<style lang="scss" scopd>
.situation-container {
  box-sizing: border-box;
  padding: 20px;
  // height: 300px;
  width: 100%;
  // background-color: #fff;
  .situation-head {
    display: flex;
    // justify-content: space-between;
  }
  // .analyze-data {
  //   padding: 20px 0;
  // }
}
</style>
